import { Options } from "validate-typescript";

export type YesNo = "t" | "n";
export const schemaYesNo = Options(["t", "n"]) as YesNo;

export type Dzial = "imp" | "wyd" | "utw" | "nos" | 'uzy';
export const schemaDzial = Options(["imp", "wyd", "utw", "nos", "uzy"]) as Dzial;
